import React from 'react';
import AlarmIndicatorsPage from './AlarmIndicatorsPage';
import { connect } from 'react-redux';
import { configureActions } from '../../../../actions/configure.action';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import helper from '../../../../utils/helper';
import lookupActions from '../../../../actions/lookup.actions';
import { bindActionCreators } from 'redux';

class AlarmIndicators extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      alarmIndicators: [],
      loading: false,
      errors: '',
      deptId: undefined,
      openModal: false,
      selectedRow: null,
      isFetching: false,
    };
    this.columns = [
      { dataField: 'indicatorId', text: 'Alarm Indicator ID', sort: true },
      { dataField: 'description', text: 'Remote Station Name', sort: true },
    ];
    this.defaultSorted = [
      {
        dataField: 'indicatorId',
        order: 'asc',
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Configure sensors',
          action: (row, rowIndex) => {
            this.props.history.push(
              `/configure/alarm-indicators/configure-sensors/${row.id}?remoteName=${row.description}`,
            );
          },
        },
        {
          name: 'Delete alarm indicator',
          action: (row, rowIndex) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.alarmIndicators !== prevState.alarmIndicators) {
      state.alarmIndicators = nextProps.configure.alarmIndicators;
    }
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.lookup.errors,
    ]);
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    if (nextProps.configure.isFetching !== prevState.isFetching) {
      state.isFetching = nextProps.configure.isFetching;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    await this.props.lookupActions.getDepartments().then((resp) => {
      let deptId = helper.parseQueryString(this.props.location.search).deptId;
      if (deptId) {
      } else {
        deptId = helper.getUserDepartment(resp).deptId;
      }
      this.setState({ deptId: parseInt(deptId) }, async () => {
        await this.props.configureActions.getAIsByDept(parseInt(deptId));
        this.props.history.replace(
          `/configure/alarm-indicators?deptId=${deptId}`,
        );
      });
    });
  }
  componentDidUpdate(prevProps, prevState) {
    const propsDept = helper.parseQueryString(
      this.props.location.search,
    ).deptId;
    if (propsDept && parseInt(propsDept) !== this.state.deptId) {
      this.setState(
        { deptId: parseInt(propsDept) },
        async () =>
          await this.props.configureActions.getAIsByDept(parseInt(propsDept)),
      );
    }
  }
  onChangeDept = (deptId) => {
    this.setState(
      { deptId },
      async () => await this.props.configureActions.getAIsByDept(deptId),
    );
  };
  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };

  onDeleteAlarmIndicator = () => {
    const { selectedRow } = this.state;
    this.setState(
      { openModal: false },
      async () =>
        await this.props.configureActions
          .deleteAlarmIndicator(selectedRow.id)
          .then(
            async () =>
              await this.props.configureActions.getAIsByDept(this.state.deptId),
          ),
    );
  };
  render() {
    const { loading } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <AlarmIndicatorsPage
        {...this.state}
        onChangeDept={(deptId) =>
          this.props.history.push(
            `/configure/alarm-indicators?deptId=${deptId}`,
          )
        }
        datagridProps={{
          columns: this.columns,
          defaultSorted: this.defaultSorted,
        }}
        ctxMenuOptions={this.ctxMenuOptions}
        onCancel={this.onCancel}
        onDeleteAlarmIndicator={this.onDeleteAlarmIndicator}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    lookup: state.lookup,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AlarmIndicators);
